import React from 'react';
import { CSSZSickLeaveCertificate } from '../../Interfaces/CSSZ.interface';
import styles from './CSSZSickLeaveCertificateListItem.module.scss';
import FormattedMomentDate, {
	DateFormat,
} from '../../../Base/Components/FormattedMomentDate/FormattedMomentDate';
import { getMomentDate } from '../../../../Utils/dates.util';
import { joinClasses } from '../../../../Utils/className.util';
import Text from '../../../../Components/Base/Text/Text';
import moment from 'moment';
import { getSickLeaveStatusTranslationKey } from '../../Helpers/sickLeaveStatusMap.helper';

interface Props {
	item: CSSZSickLeaveCertificate;
	onClick: (item: CSSZSickLeaveCertificate) => void;
	isActive: boolean;
}

const CSSZSickLeaveCertificateListItem: React.FC<Props> = ({
	item,
	onClick,
	isActive,
}) => {
	const dateFrom = item.data?.sickLeave?.dateFrom;
	const dateTo = (item as any)?.data?.sickLeave?.dateTo as string | undefined;
	const durationDays =
		dateFrom && dateTo
			? moment(dateTo)
					.startOf('day')
					.diff(moment(dateFrom).startOf('day'), 'days')
			: null;

	return (
		<div
			className={joinClasses([styles.wrapper, isActive && styles.active])}
			onClick={() => onClick(item)}>
			<div className={styles.row}>
				<div className={styles.decisionNumber}>{item.data.decisionNumber}</div>
				<div className={styles.diagnosis}>
					{item.data?.sickLeave?.diagnosis ?? ''}
				</div>
			</div>
			<div className={styles.row}>
				<div className={styles.date}>
					<FormattedMomentDate
						date={getMomentDate(dateFrom)}
						format={DateFormat.DATE}
					/>
				</div>
				<div className={styles.status}>
					<Text
						tx={getSickLeaveStatusTranslationKey(item.status) ?? item.status}
						inline
					/>
				</div>
			</div>
			{durationDays && durationDays > 0 && (
				<div className={styles.bottomRow}>
					<span className={styles.duration}>{durationDays} dní</span>
				</div>
			)}
		</div>
	);
};

export default CSSZSickLeaveCertificateListItem;
